import { render, staticRenderFns } from "./academic-details.vue?vue&type=template&id=f58bab38&"
import script from "./academic-details.vue?vue&type=script&lang=js&"
export * from "./academic-details.vue?vue&type=script&lang=js&"
import style0 from "./academic-details.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f58bab38')) {
      api.createRecord('f58bab38', component.options)
    } else {
      api.reload('f58bab38', component.options)
    }
    module.hot.accept("./academic-details.vue?vue&type=template&id=f58bab38&", function () {
      api.rerender('f58bab38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/projects/academic-details.vue"
export default component.exports